export function SPURETEXT(str) {
  return str
}
